<div [hidden]="!hasPermissionToSearch">
  <dx-lookup #distributionLookup [dataSource]="distributionDataSource" [disabled]="isReadOnly" displayExpr="PartnerName" [showClearButton]="true"
    (onValueChanged)="distributionSelectedInternal($event)" [isValid]="!isRequired">
    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
    <div *dxTemplate="let distribution of 'item'">
      @if (distribution.moreResultTemplate) {
        <p class="alert alert-warning">
          Search returned too many results. Please refine search criteria for more specific results.
        </p>
      }
      @if (!distribution.moreResultTemplate) {
        <p class=" list-group-item-text">
          @if (distribution.FromPartner) {
            <span>From: <strong>{{distribution.FromPartner}}</strong></span>
          }
          @if (distribution.FromPartner && distribution.ToPartner) {
            <span> - </span>
          }
          @if (distribution.ToPartner) {
            <span>To: <strong>{{distribution.ToPartner}}</strong></span>
          }
          <span> ({{distribution.DistributionId}})</span>
          @if (isFallbackDistribution(distribution)) {
            <span> (Fallback)</span>
          }
          @if (!distribution.IsActive) {
            <span> (<strong>Disabled</strong>)</span>
          }
        </p>
        <p class="list-group-item-text">
          Document type: {{distribution.DistributionObjectName}}
        </p>
        <p class="list-group-item-text">
          <span>In: {{distribution.FromFormat}} / {{distribution.FromVariant}} / {{distribution.FromVersion}}</span>
          <span> - </span>
          <span>Out: {{distribution.ToFormat}} / {{distribution.ToVariant}} / {{distribution.ToVersion}}</span>
        </p>
        <p class="list-group-item-text">
          Transport: {{distribution.TransportConfigurationTo}}
        </p>
      }
    </div>
  </dx-lookup>
</div>
<div [hidden]="hasPermissionToSearch">
  <i>You don't have the required permission (Distribution_View_Search) to perform a partner search.</i>
</div>
@if (showLoadingDetails && loadingDetails) {
  <span>
    <img src="../../images/ajax-loader.gif" alt="Loading distribution details..." /> Loading distribution details...
  </span>
}
